import { memo } from "react";
import moment from "moment";

import ActionButtons from "./components/action-buttons";

function Index({ mapData = [], editModalHandler }) {
  return (
    <div className="row_boxes row_boxes_table">
      <div className="table_box mt-4">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Type</th>
              <th>Email Address</th>
              <th>Access Level</th>
              <th>Assigned Task</th>
              <th>Account Status</th>
              <th>Registered On</th>
              <th>Last Login</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {mapData?.map((item, i) => {
              return (
                <tr key={item._id}>
                  <td>{i + 1}</td>
                  <td>
                    <span style={{ display: "block" }}>{item.company}</span>
                    <span>{item.fullName}</span>
                  </td>
                  <td>
                    <span
                      className={`badge badge-${
                        item.internalExternalLevel === "internal"
                          ? "success"
                          : "warning"
                      }`}
                    >
                      {item.internalExternalLevel}
                    </span>
                  </td>
                  <td>{item.email}</td>
                  <td
                    style={{
                      textTransform: "capitalize",
                    }}
                  >
                    {item.role}
                  </td>
                  <td>{item?.ticketCount || 0}</td>
                  <td
                    style={{
                      textTransform: "capitalize",
                      color:
                        item?.active === false
                          ? "#FF0000"
                          : item.passwordReset
                          ? "#5CB65F"
                          : "#FFA117",
                    }}
                  >
                    {item.passwordReset === false &&
                      item.active &&
                      "Pending invitation"}
                    {item.passwordReset === true && item.active && "Active"}
                    {item.active === false && "Inactive"}
                  </td>
                  <td>{moment(item.createdAt).format("DD/MM/YYYY hh:mm a")}</td>
                  <td>
                    {moment(item.lastActivity).format("DD/MM/YYYY hh:mm a")}
                  </td>
                  <td>
                    <ActionButtons
                      editModalHandler={() => editModalHandler(item)}
                      showReminder={!item.passwordReset}
                      rowData={item}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default memo(Index);
